require('../../modules/es7.object.get-own-property-descriptors');
module.exports = require('../../modules/_core').Object.getOwnPropertyDescriptors;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/object/get-own-property-descriptors.js
// module id = IdkE
// module chunks = 0